import React from 'react';
import { BellIcon } from '@heroicons/react/24/outline';

const NotificationPreferences = () => {
  return (
    <div>
      <div className="md:flex md:items-center md:justify-between">
        <div className="flex-1 min-w-0">
          <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
            Notification Preferences
          </h2>
          <p className="mt-1 text-gray-600">
            Configure how and when you receive notifications
          </p>
        </div>
      </div>

      <div className="mt-8">
        <div className="bg-white shadow rounded-lg p-6">
          <div className="flex items-center mb-4">
            <BellIcon className="h-6 w-6 text-gray-400 mr-2" />
            <h3 className="text-lg font-medium text-gray-900">Notification Settings</h3>
          </div>
          <p className="text-gray-600">
            This page will contain notification preferences for email, SMS, push notifications, and in-app alerts.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotificationPreferences;